import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { getFailedToFetchReports, getLastReportGenerationFailed } from '../common/errorMessages';
export var fetchReports = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var activeQuizId, setFetchInProgress, setQuizAnalysis, setItemAnalyses, setStatusPollingInProgress, setAnalysisError, setGenerationInProgress, addError, fetchQuizAnalysis, fetchItemAnalyses, setAnalysisFetchError, getErrorMessageForCode, _yield$Promise$all, _yield$Promise$all2, quizAnalysis, itemAnalyses, areAnalysesInProgress, areAnalysesFailed, analysisErrorCode;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          activeQuizId = _ref.activeQuizId, setFetchInProgress = _ref.setFetchInProgress, setQuizAnalysis = _ref.setQuizAnalysis, setItemAnalyses = _ref.setItemAnalyses, setStatusPollingInProgress = _ref.setStatusPollingInProgress, setAnalysisError = _ref.setAnalysisError, setGenerationInProgress = _ref.setGenerationInProgress, addError = _ref.addError, fetchQuizAnalysis = _ref.fetchQuizAnalysis, fetchItemAnalyses = _ref.fetchItemAnalyses, setAnalysisFetchError = _ref.setAnalysisFetchError, getErrorMessageForCode = _ref.getErrorMessageForCode;
          _context.prev = 1;
          setAnalysisFetchError(false);
          setFetchInProgress(true);
          _context.next = 6;
          return Promise.all([fetchQuizAnalysis(activeQuizId), fetchItemAnalyses(activeQuizId)]);
        case 6:
          _yield$Promise$all = _context.sent;
          _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
          quizAnalysis = _yield$Promise$all2[0];
          itemAnalyses = _yield$Promise$all2[1];
          areAnalysesInProgress = quizAnalysis.new_analysis_in_progress || itemAnalyses.new_analysis_in_progress;
          areAnalysesFailed = quizAnalysis.last_analysis_failed || itemAnalyses.last_analysis_failed;
          analysisErrorCode = quizAnalysis.last_analysis_failed_error_code || itemAnalyses.last_analysis_failed_error_code || null; // The failure codes should be the same for both quiz and item analyses
          setGenerationInProgress(areAnalysesInProgress);
          setStatusPollingInProgress(areAnalysesInProgress);
          setQuizAnalysis(quizAnalysis.last_successful_analysis);
          setItemAnalyses(itemAnalyses.last_successful_analysis);
          setAnalysisError(areAnalysesFailed ? getErrorMessageForCode(analysisErrorCode, getLastReportGenerationFailed()) : null);
          _context.next = 26;
          break;
        case 20:
          _context.prev = 20;
          _context.t0 = _context["catch"](1);
          setQuizAnalysis(null);
          setItemAnalyses(null);
          setAnalysisFetchError(true);
          addError(getFailedToFetchReports());
        case 26:
          _context.prev = 26;
          setFetchInProgress(false);
          return _context.finish(26);
        case 29:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[1, 20, 26, 29]]);
  }));
  return function fetchReports(_x) {
    return _ref2.apply(this, arguments);
  };
}();